export type IAddNumberType = 'buy' | 'assign' | 'app' | 'landline' | 'default'

export const resolveInitialAddNumberType = (
  unassignedCount: number,
  isGracePeriod: boolean
): IAddNumberType => {
  if (unassignedCount > 0) return 'assign'
  if (!isGracePeriod) return 'buy'

  return 'default'
}
